import { saveAs } from 'file-saver';

import { handleError } from 'services/ErrorManagement';
import { getFile, httpDelete, postFile } from 'services/Http';

export const uploadPolicyFiles = async ({ files, payerId, draftId }) => {
    try {
        await Promise.all(
            files.map(async (file) =>
                postFile(`/clinicalpolicy/admin/${payerId}/attachments/${draftId}`, file),
            ),
        );
    } catch (err) {
        handleError('An error occurred uploading files.', err);
        throw err; // Propagate error to FileUpload component
    }
};

export const downloadPolicyFile = async ({ filename, payerId, draftId }) => {
    try {
        saveAs(
            await getFile(`/clinicalpolicy/admin/${payerId}/attachments/${draftId}/${filename}`),
            filename,
        );
    } catch (err) {
        handleError(`An error occurred downloading ${filename}.`, err);
    }
};

export const removePolicyFile = async ({ filename, payerId, draftId }) => {
    try {
        await httpDelete(`/clinicalpolicy/admin/${payerId}/attachments/${draftId}/${filename}`);
    } catch (err) {
        handleError(`An error occurred deleting ${filename}.`, err);
        throw err; // Propagate error to FileUpload component
    }
};
